import React, { Component } from "react";
import { Table } from "react-bootstrap";
import { Link } from "react-router-dom";
import { utcToLocal } from "../../utils/dateConvert";

class GroupTable extends Component {

  renderSortHeader = (label, sortKey) => {
    const { onSort, sortDirection, sortKey: activeSortKey } = this.props;
    const active = activeSortKey === sortKey;
    const iconClass = active && sortDirection === "desc"
      ? "fa fa-sort-down"
      : active
        ? "fa fa-sort-up"
        : "fa fa-sort";

    return (
      <button
        className={`group-sort-button ${active ? "active" : ""}`}
        onClick={() => onSort(sortKey)}
        type="button"
      >
        {label}
        <i className={iconClass}></i>
      </button>
    );
  };

  render() {
    const { GroupList } = this.props;

    return (
      <Table className="group-table" responsive>
        <thead>
          <tr>
            <th>{this.renderSortHeader("Name", "name")}</th>
            <th>{this.renderSortHeader("Description", "description")}</th>
            <th>{this.renderSortHeader("Customer", "customerName")}</th>
            <th>Icon</th>
            <th>{this.renderSortHeader("Default", "menuDefault")}</th>
            <th>{this.renderSortHeader("Sequence", "menuPriority")}</th>
            <th>{this.renderSortHeader("Status", "status")}</th>
            <th>{this.renderSortHeader("Updated", "dbUpdated")}</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {GroupList.length === 0 && (
            <tr>
              <td className="group-empty" colSpan="9">
                No groups match your search.
              </td>
            </tr>
          )}
          {GroupList.map((group, index) => {
            const statusLabel = group.status === "Disable" ? "Disabled" : group.status || "-";
            const status = statusLabel.toLowerCase().replace(/\s+/g, "-");
            return (
              <tr key={group.id || index}>
                <td>
                  <strong>{group.name}</strong>
                </td>
                <td>{group.description || "-"}</td>
                <td>
                  <Link
                    className="group-customer-link"
                    onClick={() =>
                      localStorage.setItem(
                        "customer",
                        JSON.stringify({
                          customerId: group.customerId,
                          customerName: group.customerName,
                        })
                      )
                    }
                    to={`/groups?customerId=${encodeURIComponent(group.customerId)}&customerName=${encodeURIComponent(group.customerName)}`}
                  >
                    {group.customerName}
                  </Link>
                </td>
                <td>
                  <span className="group-icon-cell">
                    <i style={{ color: `${group.colour}` }} className={group.icon}></i>
                  </span>
                </td>
                <td>
                  <span className={`group-default ${group.menuDefault == 0 ? "" : "active"}`}>
                    {group.menuDefault == 0 ? "No" : "Yes"}
                  </span>
                </td>
                <td>{group.menuPriority}</td>
                <td>
                  <span className={`group-status group-status-${status}`}>
                    {statusLabel}
                  </span>
                </td>
                <td>{group.dbUpdated ? utcToLocal(group.dbUpdated) : ""}</td>
                <td className="group-actions">
                  <Link to={`/editGroup/${group.id}`}>Edit</Link>
                  <Link to={`/groupDetails/${group.id}`}>Details</Link>
                  <Link to={`/deleteGroup/${group.id}`}>Delete</Link>
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    );
  }
}

export default GroupTable;
